import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import skLocale from "date-fns/locale/sk"; // Import Slovak locale
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./components/admin/AdminLayout";
import UserManagement from "./components/admin/UserManagement";
import RegistrationAttendance from "./components/admin/RegistrationAttendance";
import RaceManagementStart from "./components/admin/RaceManagementStart";
import RaceManagementFinish from "./components/admin/RaceManagementFinish";
import RaceManagementCheckpoint from "./components/admin/RaceManagementCheckpoint";
import Results from "./components/admin/Results";
import WebSettings from "./components/admin/WebSettings";
import CategoryManagement from "./components/admin/CategoryManagement";
import DataExport from "./components/admin/DataExport";
import Website from "./components/public/Website";

import PageLiveResults from "./components/public/PageLiveResults";

function App() {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={skLocale}>
            <Router>
                <Routes>
                    {/* Live Results TV Endpoint */}
                    <Route path="/vysledky-live" element={<PageLiveResults />} />

                    {/* Public Website Routes */}
                    <Route path="/*" element={<Website />} />

                    {/* Admin Login */}
                    <Route path="/admin/login" element={<Login />} />

                    {/* Protected Admin Routes */}
                    <Route
                        path="/admin/*"
                        element={
                            <ProtectedRoute>
                                <AdminLayout />
                            </ProtectedRoute>
                        }
                    >
                        <Route path="user-management" element={<UserManagement />} />
                        <Route path="registration-attendance" element={<RegistrationAttendance />} />
                        <Route path="race-management/start" element={<RaceManagementStart />} />
                        <Route path="race-management/finish" element={<RaceManagementFinish />} />
                        <Route path="race-management/checkpoint" element={<RaceManagementCheckpoint />} />
                        <Route path="results" element={<Results />} />
                        <Route path="export-data" element={<DataExport />} />
                        <Route path="categories" element={<CategoryManagement />} />
                        <Route path="web-settings" element={<WebSettings />} />
                    </Route>
                </Routes>
            </Router>
        </LocalizationProvider>
    );
}

export default App;
